module.exports = "<div id=\"diagram1-4c-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram1-4c-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/diagrams/4/4c/diagram1/diagram1.html
// module id = 1349
// module chunks = 0